//noScroll
class Nav {
    constructor(el,opt){
      this.el = el;
			if($("." + this.el).length > 0){
				this.event();
			}
    }
    event(){
			window.addEventListener("resize", function(){
				const nav = document.querySelector(".menu");
				if(1200 < window.innerWidth){
					nav.classList.remove("is-active")
				};
			}
			)

  }
}